<template>
  <div>
    <loader v-if="is.loading"/>
    <template v-else>
      <order-configuration :configuration="entity.configuration" :order="entity"/>
    </template>
  </div>
</template>

<script>
import MixinEntityBase from '@/components/mixins/EntityBase'
import OrderConfiguration from '@/components/order/OrderConfiguration'
import Loader from '@/components/Loader'

export default {
    name: 'Orders.Detail',
    mixins: [MixinEntityBase],
    components: {
        OrderConfiguration,
        Loader
    },
    computed: {
        is () {
            return this.$store.getters[`${this.eParent.key}/is`]
        },
        entity () {
            return this.$store.getters[`${this.eParent.key}/getEntityUnwrapped`](this.eParent.id) || {}
        }
    }
}
</script>

<style lang="scss"></style>
